const CONTACT_FORM_ENDPOINT = 'https://www.anovator.com/CustomerResourcesAction!gform.m'
const CONTACT_FIELD_ORDER = [
  'name',
  'email',
  'whatsapp',
  'message',
  'hiddenField',
  'countryField',
  'countryCodeField',
  'countryNameField',
  'countryManualSelected',
  'dialCodeField',
  'fromPage',
  'privacyPolicyAccepted'
]

function validateContactFields(fields = {}, messages = {}) {
  const errors = {}
  const name = String(fields.name || '').trim()
  const email = String(fields.email || '').trim()
  const whatsapp = String(fields.whatsapp || '').trim()
  const message = String(fields.message || '').trim()

  if (!name) errors.name = messages.nameRequired || 'Please enter your name.'
  if (!email) {
    errors.email = messages.emailRequired || 'Please enter your email address.'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = messages.emailInvalid || 'Please enter a valid email address.'
  }

  if (!whatsapp) {
    errors.whatsapp = messages.whatsappRequired || 'Please enter your WhatsApp / phone number.'
  } else if (whatsapp.length < 6) {
    errors.whatsapp = messages.whatsappShort || 'Phone number must be at least 6 characters long.'
  } else if (!/^\+?[0-9\-()\s]+$/.test(whatsapp)) {
    errors.whatsapp = messages.whatsappInvalid || 'WhatsApp / phone number is invalid.'
  }

  if (!message) errors.message = messages.messageRequired || 'Please enter your message.'
  if (!fields.privacyPolicyAccepted) {
    errors.privacyPolicyAccepted = messages.privacyRequired || 'Please confirm that you have read and accept the Privacy Policy.'
  }

  return errors
}

async function readContactResponse(response) {
  if (!response.ok) throw new Error(`Request failed with status ${response.status}`)
  const result = await response.json()
  if (result?.STATUS !== true) throw new Error('Contact request was not accepted')
  return result
}

function createContactRequest(fields = {}) {
  const payload = {}
  CONTACT_FIELD_ORDER.forEach((name) => {
    if (name === 'privacyPolicyAccepted') {
      payload[name] = fields[name] ? 'true' : ''
      return
    }
    payload[name] = fields[name] == null ? '' : String(fields[name])
  })
  payload.formDataNameOrder = JSON.stringify(CONTACT_FIELD_ORDER)
  payload.formGoogleSheetName = 'responses'
  payload.formGoogleSendEmail = ''

  return {
    url: CONTACT_FORM_ENDPOINT,
    method: 'POST',
    contentType: 'application/x-www-form-urlencoded',
    body: new URLSearchParams(payload).toString()
  }
}

module.exports = {
  CONTACT_FORM_ENDPOINT,
  CONTACT_FIELD_ORDER,
  createContactRequest,
  readContactResponse,
  validateContactFields
}
